import { useEffect, useState } from "react";
import { fetchUpdateHistoryByChassis } from "../../../../api/fetchMaintenanceGroup"
import { IMaintenanceHistoryResponse } from "../../../../models/volksPlanEssential";
import { Spinner } from "@rio-cloud/rio-uikit";
import { useIntl } from "react-intl";
import { getMaintenanceGroupLabel } from "../enums/maintenanceGroupEnum";
import NoneHistory from "./noneHistory";

interface IHistoryGroupSidebarProps {
    chassis: string;
}

const HistoryGroupSidebar = ({ chassis }: IHistoryGroupSidebarProps) => {
    const [page, setPage] = useState(0);
    const [lastItem, setLastItem] = useState(false);
    const [content, setContent] = useState<IMaintenanceHistoryResponse['content'] >([]);
    const [loading, setLoading] = useState(false);

    const intl = useIntl();

    const getUpdateHistoryByChassis = async () => {
        setLoading(true);
        const newPage = page + 1
        const result = await fetchUpdateHistoryByChassis(chassis, 3, newPage)

        if(!result) return

        const isLastItem = result?.last;

        setContent([...content, ...(result?.content ?? [])])
        setLastItem(isLastItem);
        setPage(newPage);
        setLoading(false);
    } 

    useEffect(() => {
        if(content.length) return;
        getUpdateHistoryByChassis()
    }, [chassis])

    return (
        <div className="relative">
            {content?.length ? <div className="absolute left-10 top-0 bottom-0 w-px border-l-2 border-dashed border-gray-200 pointer-events-none -z-0" />: null}

            {loading ? (
                <div className="flex items-center justify-center py-8">
                    <div className="">
                        <Spinner />
                        <p className="spinnerText">{intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.history.loading" })}</p>
                    </div>
                </div>
            ) : null}

            {!loading ? (
                <div>
                    {content?.map(logItem => (
                        <div className="space-y-8" key={logItem.id}>
                            <div className="relative flex items-start">
                                <div className="w-16 flex-shrink-0 flex justify-start z-10">
                                    <div className="flex items-center justify-center w-10 h-10 bg-slate-100 rounded-full border border-gray-200 shadow-sm">
                                        <span className="rioglyph rioglyph-ok text-slate-700" />
                                    </div>
                                </div>

                                <div className="flex-1 mb-10">
                                    <div className="bg-white rounded-xl border border-gray-200 p-4 sm:p-6">
                                        <div className="flex flex-col sm:flex-row sm:space-x-6">
                                            <div className="w-full">
                                                <div className="flex flex-row items-start justify-between sm:w-7/12">
                                                    <div className="flex flex-row items-center">
                                                        <div className="h-20 bg-slate-200" style={{width: 0}}></div>
                                                        <div className="flex flex-col">
                                                            <span className="font-semibold  text-gray-600 ">{intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.history.user" })}:</span>{' '}
                                                            <span className="">{logItem?.userName}</span>
                                                        </div>
                                                    </div>

                                                    <div className="flex flex-row items-center gap-20">
                                                        <div className="h-20 bg-slate-200" style={{width: 1}}></div>
                                                        <div className="flex flex-col">
                                                            <span className="font-semibold text-gray-600">{intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.history.dateTime" })}:</span>{' '}
                                                            <span className="font-medium ">
                                                                {new Date(logItem?.createdAt).toLocaleDateString("pt-BR")}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="flex flex-row items-center gap-20">
                                                        <div className="h-20 bg-slate-200" style={{width: 1}}></div>
                                                        <div className="flex flex-col">
                                                            <span className="font-semibold text-gray-600">{intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.history.fieldChanged" })}:</span>{' '}
                                                        <span className="font-medium ">{intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.history.maintenanceGroup" })}</span>
                                                        </div>
                                                    </div>

                                                </div>


                                                <div className="flex gap-20 mt-5">
                                                    <div className="w-[350px]">
                                                        <div className="font-semibold text-gray-600">{intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.history.previousValue" })}:</div>
                                                        <div className="mt-2 bg-gray-50 border border-gray-100 rounded-md p-3  text-gray-600">
                                                            {getMaintenanceGroupLabel(logItem?.data[0]?.oldData ?? '-')} 
                                                        </div>
                                                    </div>
                                                    <div className="flex flex-row items-center gap-20">
                                                        <div className="w-1 h-full bg-slate-200"></div>
                                                        <div className="w-[350px]">
                                                            <div className="font-semibold text-gray-600">{intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.history.newValue" })}:</div>
                                                            <div className="mt-2 bg-gray-50 border border-gray-100 rounded-md p-3  text-gray-600">
                                                                {getMaintenanceGroupLabel(logItem?.data[0]?.newData ?? '-')} 
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    {content?.length ? null : <NoneHistory />}
                    <div className="flex justify-center">
                        {lastItem ? null : (
                            <button onClick={getUpdateHistoryByChassis} type="button" className="btn btn-primary">
                                <span className="text-capitalize">{intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.history.loadMore" })}</span>
                            </button>
                        )}
                    </div>
                </div>
            ) : null}
        </div>
    )
}

export default HistoryGroupSidebar